import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import './Gestiondesstocks.css';
import Card24 from '../components/Card24';
import Card25 from '../components/Card25';
import Card26 from '../components/Card26';
import Card27 from '../components/Card27';
import Card39 from '../components/Card39';
import Card43 from '../components/Card43';
import Camembert2 from '../components/Camembert2';
import Camembert4 from '../components/Camembert4';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const CARD25_CONFIG = {
  inputBlock: { top: '260px', left: '680px' },
  btnValider:  { top: '260px', left: '1200px' },
};

const TABLE39_COLUMNS = ['Date', 'De', 'Description', 'Commentaires', 'Statut', 'Numero tache'];

const getTable39ColWidth = (col) =>
  col === 'Date'         ? '80px'  :
  col === 'De'           ? '80px'  :
  col === 'Description'  ? '260px' :
  col === 'Statut'       ? '100px' :
  col === 'Numero tache' ? '60px'  :
  col === 'Commentaires' ? '320px' : '150px';

const formatDate = (v) => {
  if (!v) return '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(String(v))) return v;
  const d = new Date(v);
  if (isNaN(d)) return v;
  return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
};

const DATE_COLS_INVENTAIRE   = ['Date lancement inventaire', 'Date dernier inventaire'];
const HIDDEN_COLS_AVANCEMENT = ['ID', 'Client_id'];

const getStatutClass = (val) =>
  val === 'ouvert'   ? 'statut-ouvert'  :
  val === 'en cours' ? 'statut-encours' :
  val === 'soldé'    ? 'statut-solde'   : '';

const getResultatClass = (val) =>
  val === 'ok' ? 'statut-solde'  :
  val === 'ko' ? 'statut-ouvert' : '';

const Gestiondesstocks = () => {
  const [data, setData]                       = useState([]);
  const [avancementData, setAvancementData]   = useState([]);
  const [filteredData, setFilteredData]       = useState([]);
  const [emplacementData, setEmplacementData] = useState([]);
  const [tachesData, setTachesData]           = useState([]);
  const [nouvelleItem, setNouvelleItem]       = useState('');
  const [allItems, setAllItems]               = useState([]);
  const [showItemSuggestions, setShowItemSuggestions] = useState(false);
  const [saveMsg, setSaveMsg]                 = useState('');
  const [inventaireSelection, setInventaireSelection] = useState({});
  const [saveLancementMsg, setSaveLancementMsg] = useState('');

  const [showDuplicatesOnly, setShowDuplicatesOnly]                         = useState(false);
  const [showDuplicatesDepotEmplacement, setShowDuplicatesDepotEmplacement] = useState(false);
  const [card24Clicked, setCard24Clicked] = useState(false);
  const [card25Clicked, setCard25Clicked] = useState(false);
  const [card26Clicked, setCard26Clicked] = useState(false);
  const [card27Clicked, setCard27Clicked] = useState(false);
  const [card39Clicked, setCard39Clicked] = useState(false);
  const [card43Clicked, setCard43Clicked] = useState(false);
  const [multiRefData, setMultiRefData]   = useState([]);
  const [searchItem, setSearchItem]       = useState('');
  const [isChartVisible, setIsChartVisible] = useState(true);

  useEffect(() => {                                    // ← ajouter ici
    document.title = 'MYSSA – Gestion des stocks';
  }, []);

  // ─────────────────────────────────────────────────────────────
  // Helpers doublons (Card43)
  // ─────────────────────────────────────────────────────────────
  const getDuplicateItems = (rows) => {
    const counts = {};
    rows.forEach(r => { if (r.Item) counts[r.Item] = (counts[r.Item] || 0) + 1; });
    return Object.keys(counts).filter(k => counts[k] > 1);
  };

  const getDuplicateDepotEmplacementPairs = (rows) => {
    const counts = {};
    rows.forEach(r => {
      const key = `${r['Nom Dépôt']}||${r['Emplacement']}`;
      counts[key] = (counts[key] || 0) + 1;
    });
    return Object.keys(counts).filter(k => counts[k] > 1);
  };

  // ─────────────────────────────────────────────────────────────
  // Export Excel d'une ligne (Card24)
  // ─────────────────────────────────────────────────────────────
  const exportRowToExcel = (row) => {
    const today = new Date();
    const dateStr = `${String(today.getDate()).padStart(2,'0')}/${String(today.getMonth()+1).padStart(2,'0')}/${today.getFullYear()}`;
    const titre = `Inventaire de ${row['Item'] || ''} - ${row['Description'] || ''} ${dateStr}`;

    const cols = Object.keys(row).filter(c => !HIDDEN_COLS_AVANCEMENT.includes(c));

    const aoa = [
      [titre],
      [],
      cols,
      cols.map(c => {
        const v = row[c];
        if (v == null) return '';
        if (['date inventaire'].includes(c)) return formatDate(v);
        return v;
      }),
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // Merge titre sur toute la largeur
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: cols.length - 1 } }];

    // Largeurs colonnes
    ws['!cols'] = cols.map(() => ({ wch: 22 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inventaire');
    XLSX.writeFile(wb, `Inventaire_${row['Item'] || 'item'}_${dateStr.replace(/\//g, '-')}.xlsx`);
  };

  // ─────────────────────────────────────────────────────────────
  // Chargement principal
  // ─────────────────────────────────────────────────────────────
  const loadAvancement = () => {
    Promise.all([
      fetch(`${API}/avancement_inventaire`).then(r => r.json()),
      fetch(`${API}/inventaire_a_faire`).then(r => r.json()),
    ]).then(([avancement, inventaire]) => {

      setAvancementData(avancement.map(({ ID, Client_id, ...rest }) => rest));

      const actifs = avancement.filter(row => {
        const s = String(row['status'] || row['Status'] || '').trim().toLowerCase();
        return s === 'à faire' || s === 'en cours';
      });
      setFilteredData(actifs.map(row => ({
        ...row,
        '1er comptage':  row['1er comptage']  ?? '',
        '2ème comptage': row['2ème comptage'] ?? '',
        '3ème comptage': row['3ème comptage'] ?? '',
        causes:          row['causes']         ?? '',
        resultat:        row['resultat']        || 'ok',
        status:          row['status']          || 'à faire',
      })));

      const itemsActifs = new Set(
        avancement
          .filter(r => String(r['status'] || '').trim().toLowerCase() !== 'soldé')
          .map(r => String(r['Item'] || '').trim().toLowerCase())
      );
      const inventaireFiltré = inventaire.filter(r =>
        !itemsActifs.has(String(r['Item'] || '').trim().toLowerCase())
      );
      setData(inventaireFiltré.map(({ ID, Client_id, ...rest }) => rest));
      setInventaireSelection({});

    }).catch(e => console.error('Erreur chargement avancement/inventaire:', e));
  };

  useEffect(() => { loadAvancement(); }, []);

  useEffect(() => {
    fetch(`${API}/donnee_histogramme`)
      .then(r => r.json())
      .then(raw => {
        const items = [...new Set(raw.map(d => d['Item']).filter(Boolean))].sort();
        setAllItems(items);
      })
      .catch(e => console.error('Erreur items:', e));
  }, []);

  useEffect(() => {
    fetch(`${API}/emplacement_vide`)
      .then(r => r.json())
      .then(raw => setEmplacementData(raw.map(({ ID, Id, client_id, Client_id, ...rest }) => rest)))
      .catch(e => console.error('Erreur emplacement_vide:', e));
  }, []);

  const loadTachesLog = async () => {
    try {
      const res  = await fetch(`${API}/taches`);
      const rows = await res.json();
      const formatted = rows
        .map(({ ID, Client_id, Date: rawDate, ...rest }) => ({
          ...rest,
          Date: isNaN(new Date(rawDate)) ? '' : formatDate(new Date(rawDate)),
        }))
.filter(r =>
  String(r['Département'] || r['Departement'] || '').toUpperCase() === 'LOG' &&
  ['ouvert', 'en cours'].includes(String(r['Statut'] || '').toLowerCase())
)
.sort((a, b) => new Date(a['Date'] || 0) - new Date(b['Date'] || 0));
      setTachesData(formatted);
    } catch (e) { console.error('Erreur tâches LOG:', e); }
  };

  const handleInputChange = (index, column, value) => {
    setFilteredData(prev => {
      const next = [...prev];
      next[index] = { ...next[index], [column]: value };
      return next;
    });
  };

  const handleSaveAvancement = async (row) => {
    const payload = {
      ID:              row['ID'],
      Client_id:       row['Client_id'] || 'Client_A',
      '1er comptage':  row['1er comptage']  !== '' ? row['1er comptage']  : null,
      '2ème comptage': row['2ème comptage'] !== '' ? row['2ème comptage'] : null,
      '3ème comptage': row['3ème comptage'] !== '' ? row['3ème comptage'] : null,
      resultat:        row['resultat'] || null,
      causes:          row['causes']   || null,
      status:          row['status']   || 'à faire',
    };
    try {
      const res  = await fetch(`${API}/avancement_inventaire/update`, {
        method:  'PUT',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload),
      });
      const json = await res.json();
      if (!json.success) console.error('Erreur sauvegarde :', json.error);
    } catch (e) { console.error('Erreur fetch handleSaveAvancement :', e); }
  };

  const handleEnregistrerInventaire = async () => {
    if (!nouvelleItem.trim()) {
      setSaveMsg('⚠️ Saisissez un item');
      setTimeout(() => setSaveMsg(''), 3000);
      return;
    }
    try {
      const res = await fetch(`${API}/avancement_inventaire`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          item:   nouvelleItem.trim(),
          status: 'à faire',
        }),
      });
      const json = await res.json();
      if (json.success) { setSaveMsg('✅ Enregistré'); setNouvelleItem(''); loadAvancement(); }
      else setSaveMsg('❌ Erreur : ' + json.error);
    } catch (e) { setSaveMsg('❌ Erreur serveur'); console.error(e); }
    setTimeout(() => setSaveMsg(''), 4000);
  };

  const handleValiderLancement = async () => {
    const selection = data.filter((_, i) => inventaireSelection[i]);
    if (selection.length === 0) {
      setSaveLancementMsg('⚠️ Aucune ligne sélectionnée');
      setTimeout(() => setSaveLancementMsg(''), 3000);
      return;
    }
    let ok = 0, ko = 0;
    for (const row of selection) {
      try {
        const res  = await fetch(`${API}/avancement_inventaire`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ item: row['Item'], description: row['Description'] || '', stock: row['Stock actuel'] || null, status: 'à faire' }),
        });
        const json = await res.json();
        if (json.success) ok++; else ko++;
      } catch { ko++; }
    }
    setSaveLancementMsg(ko === 0 ? `✅ ${ok} inventaire(s) lancé(s)` : `⚠️ ${ok} OK / ${ko} erreur(s)`);
    setInventaireSelection({});
    loadAvancement();
    setTimeout(() => setSaveLancementMsg(''), 4000);
  };

  const handleCardClick = (card) => {
    setCard24Clicked(card === 'card24');
    setCard25Clicked(card === 'card25');
    setCard26Clicked(card === 'card26');
    setCard27Clicked(card === 'card27');
    setCard39Clicked(card === 'card39');
    setCard43Clicked(card === 'card43');
    setIsChartVisible(false);
    if (card === 'card24' || card === 'card25' || card === 'card26') loadAvancement();
    if (card === 'card39') loadTachesLog();
    if (card === 'card43') {
      fetch(`${API}/emplacement_multi_ref`)
        .then(r => r.json())
        .then(raw => setMultiRefData(raw.map(({ ID, Id, client_id, Client_id, ...rest }) => rest)))
        .catch(e => console.error('Erreur emplacement_multi_ref:', e));
    }
  };

  const saveTacheCommentaire = async (row) => {
    try {
      await fetch(`${API}/taches/update`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ numero_tache: row['Numero tache'], commentaire: row['Commentaires'] || '', statut: row['Statut'] || 'ouvert' }),
      });
      if (String(row['Numero tache']).startsWith('A')) {
        await fetch(`${API}/base_commentaire_animation/update`, {
          method: 'PUT', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ numero_tache: row['Numero tache'], commentaire: row['Commentaires'] || '' }),
        });
      }
    } catch (e) { console.error('Erreur sauvegarde tâche LOG:', e); }
  };

  const handleTacheStatutChange = async (rowIndex, newStatut) => {
    const newData = [...tachesData];
    newData[rowIndex]['Statut'] = newStatut;
    setTachesData(newData);
    const row = newData[rowIndex];
    try {
      await fetch(`${API}/taches/update`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ numero_tache: row['Numero tache'], commentaire: row['Commentaires'] || '', statut: newStatut }),
      });
    } catch (e) { console.error('Erreur statut tâche LOG:', e); }
  };

  const handleTacheCommentaireChange = (rowIndex, value) => {
    setTachesData(prev => {
      const next = [...prev];
      next[rowIndex]['Commentaires'] = value;
      return next;
    });
  };

  const avancementCols = filteredData.length > 0
    ? Object.keys(filteredData[0]).filter(c => !HIDDEN_COLS_AVANCEMENT.includes(c))
    : [];

  const inventaireColumns = data.length > 0 ? Object.keys(data[0]) : [];

  // ─────────────────────────────────────────────────────────────
  // Icône Excel SVG
  // ─────────────────────────────────────────────────────────────
  const ExcelIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#1D6F42"/>
      <path d="M13 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8l-5-5z" fill="#fff" fillOpacity="0.15"/>
      <path d="M13 3v5h5" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 12l2 3 2-3M9 18l2-3 2 3" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <div className="approvisionnement-container">

      {/* Bandeau titre */}
      <div style={{ position: 'absolute', top: '25px', left: '170px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px' }} />
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '200', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d' }}>
          Gestion des stocks
        </span>
      </div>

      {/* ═══════════════════════════════ CARD 24 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '350px' }} onClick={() => handleCardClick('card24')}>
        <Card24 />
      </div>

      {card24Clicked && (
        <>
          {/* Input + bouton Enregistrer */}
          <div style={{ position: 'absolute', top: CARD25_CONFIG.inputBlock.top, left: CARD25_CONFIG.inputBlock.left, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="Entrer une référence"
                value={nouvelleItem}
                onChange={e => { setNouvelleItem(e.target.value); setShowItemSuggestions(true); }}
                onFocus={() => setShowItemSuggestions(true)}
                onBlur={() => setTimeout(() => setShowItemSuggestions(false), 150)}
                style={{ padding: '10px', fontSize: '16px', borderRadius: '6px', border: '1px solid #ccc', width: '250px' }}
                autoComplete="off"
              />
              {showItemSuggestions && nouvelleItem && (
                <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 9999, background: '#fff', border: '1.5px solid #ddd', borderRadius: '7px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxHeight: 200, overflowY: 'auto', width: '250px', marginTop: 4 }}>
                  {allItems
                    .filter(r => r.toLowerCase().includes(nouvelleItem.toLowerCase()))
                    .slice(0, 30)
                    .map((ref, i) => (
                      <div key={i}
                        onMouseDown={() => { setNouvelleItem(ref); setShowItemSuggestions(false); }}
                        style={{ padding: '8px 12px', fontSize: '13px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                      >{ref}</div>
                    ))}
                </div>
              )}
            </div>
            <button onClick={handleEnregistrerInventaire}
              style={{ padding: '10px 20px', fontSize: '16px', borderRadius: '6px', background: 'radial-gradient(circle, rgb(115,157,199) 0%, rgba(173,216,230,1) 100%)', color: 'white', border: 'none', cursor: 'pointer' }}>
              Enregistrer
            </button>
            {saveMsg && (
              <span style={{ fontSize: '13px', fontWeight: 700, color: saveMsg.startsWith('✅') ? '#2e7d32' : '#c62828' }}>{saveMsg}</span>
            )}
          </div>

          {/* Tableau avancement_inventaire */}
          <div className="table-containerstock">
            {filteredData.length === 0 ? (
              <p style={{ padding: '20px', color: '#888' }}>Aucun inventaire en cours.</p>
            ) : (
              <table className="inventory-table">
                <thead>
                  <tr>
                    {avancementCols.map((col, i) => <th key={i}>{col}</th>)}
                    <th style={{ width: '44px', textAlign: 'center' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr key={index}>
                      {avancementCols.map((col, colIndex) => {
                        const isEditable = ['1er comptage', '2ème comptage', '3ème comptage', 'resultat', 'causes', 'status'].includes(col);
                        const tdClass =
                          col === 'resultat' ? getResultatClass(row['resultat']) :
                          col === 'status'   ? getStatutClass(row['status'])    : '';
                        return (
                          <td key={colIndex} className={tdClass}>
                            {isEditable ? (
                              col === 'resultat' ? (
                                <select
                                  value={row['resultat'] || 'ok'}
                                  onChange={e => handleInputChange(index, 'resultat', e.target.value)}
                                  onBlur={() => handleSaveAvancement(filteredData[index])}
                                >
                                  <option value="ok">ok</option>
                                  <option value="ko">ko</option>
                                </select>
                              ) : col === 'status' ? (
                                <select
                                  value={row['status'] || 'à faire'}
                                  onChange={e => handleInputChange(index, 'status', e.target.value)}
                                  onBlur={() => handleSaveAvancement(filteredData[index])}
                                >
                                  <option value="à faire">à faire</option>
                                  <option value="en cours">en cours</option>
                                  <option value="soldé">soldé</option>
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  value={row[col] || ''}
                                  onChange={e => handleInputChange(index, col, e.target.value)}
                                  onBlur={() => handleSaveAvancement(filteredData[index])}
                                />
                              )
                            ) : (
                              col === 'date inventaire' ? formatDate(row[col]) : (row[col] ?? '')
                            )}
                          </td>
                        );
                      })}
                      {/* Colonne Excel */}
                      <td
                        style={{ textAlign: 'center', verticalAlign: 'middle', cursor: 'pointer', padding: '4px' }}
                        title="Exporter en Excel"
                        onClick={e => { e.stopPropagation(); exportRowToExcel(row); }}
                      >
                        <ExcelIcon />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}

      {/* ═══════════════════════════════ CARD 25 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '600px' }} onClick={() => handleCardClick('card25')}>
        <Card25 />
      </div>

      {card25Clicked && (
        <>
          <div style={{ position: 'absolute', top: CARD25_CONFIG.btnValider.top, left: CARD25_CONFIG.btnValider.left, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button onClick={handleValiderLancement}
              style={{ padding: '10px 20px', fontSize: '16px', borderRadius: '6px', background: 'linear-gradient(135deg, #3a7d44, #66bb6a)', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
              ✅ Valider lancement inventaire
            </button>
            {saveLancementMsg && (
              <span style={{ fontSize: '13px', fontWeight: 700, color: saveLancementMsg.startsWith('✅') ? '#2e7d32' : '#c62828' }}>{saveLancementMsg}</span>
            )}
          </div>

          <div className="table-containerstock">
            <table className="inventory-table">
              <thead>
                <tr>
                  <th style={{ width: '120px', textAlign: 'center' }}>Lancer inventaire</th>
                  {inventaireColumns.map((col, i) => <th key={i}>{col}</th>)}
                </tr>
              </thead>
              <tbody>
                {data.map((row, i) => (
                  <tr key={i}>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <input type="checkbox" checked={!!inventaireSelection[i]}
                        onChange={e => setInventaireSelection(prev => ({ ...prev, [i]: e.target.checked }))}
                        style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#3a7d44' }} />
                    </td>
                    {inventaireColumns.map((col, j) => (
                      <td key={j}>{DATE_COLS_INVENTAIRE.includes(col) ? formatDate(row[col]) : (row[col] ?? '')}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ═══════════════════════════════ CARD 26 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '850px' }} onClick={() => handleCardClick('card26')}>
        <Card26 />
      </div>

      {card26Clicked && (
        <div className="table-containerstock">
          <input type="text" placeholder="Filtrer par Item..." value={searchItem}
            onChange={e => setSearchItem(e.target.value)}
            style={{ marginBottom: '10px', padding: '8px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc', width: '250px' }} />
          <table className="inventory-table">
            <thead>
              <tr>{Object.keys(avancementData[0] || {}).map((col, i) => <th key={i}>{col}</th>)}</tr>
            </thead>
            <tbody>
              {avancementData
                .filter(row => row.Item?.toLowerCase().includes(searchItem.toLowerCase()))
                .map((row, i) => {
                  const s = String(row['status'] || row['Status'] || '').trim().toLowerCase();
                  const bgColor =
                    s === 'à faire'  ? 'rgba(255, 213, 79,  0.35)' :
                    s === 'en cours' ? 'rgba(100, 181, 246, 0.35)' :
                    row.resultat === 'ok' ? 'rgba(144, 238, 144, 0.5)' :
                    row.resultat         ? 'rgba(255, 99,  71,  0.5)' : '';
                  return (
                    <tr key={i} style={{ backgroundColor: bgColor }}>
                      {Object.keys(row).map((col, j) => (
                        <td key={j}>{col === 'date inventaire' ? formatDate(row[col]) : (row[col] ?? '')}</td>
                      ))}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}

      {/* ═══════════════════════════════ CARD 43 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '1100px' }} onClick={() => handleCardClick('card43')}>
        <Card43 />
      </div>

      {card43Clicked && (
        <>
          <div className="checkbox-container" style={{ position: 'relative', top: '260px', left: '250px', marginBottom: '-60px', display: 'flex', alignItems: 'center', gap: '200px' }}>
            <label style={{ fontWeight: 'bold' }}>
              <input type="checkbox" checked={showDuplicatesOnly} onChange={e => setShowDuplicatesOnly(e.target.checked)} style={{ marginRight: '6px' }} />
              Référence multi emplacement
            </label>
            <label style={{ fontWeight: 'bold' }}>
              <input type="checkbox" checked={showDuplicatesDepotEmplacement} onChange={e => setShowDuplicatesDepotEmplacement(e.target.checked)} style={{ marginRight: '6px' }} />
              Emplacement multi référence
            </label>
          </div>
          <div className="table-containerstock">
            <table className="inventory-table">
              <thead>
                <tr>{Object.keys(multiRefData[0] || {}).map((col, i) => <th key={i}>{col}</th>)}</tr>
              </thead>
              <tbody>
                {(() => {
                  let lastPair = null;
                  let colorToggle = false;
                  return multiRefData
                    .filter(row => {
                      if (showDuplicatesDepotEmplacement) return getDuplicateDepotEmplacementPairs(multiRefData).includes(`${row['Nom Dépôt']}||${row['Emplacement']}`);
                      if (showDuplicatesOnly) return getDuplicateItems(multiRefData).includes(row.Item);
                      return true;
                    })
                    .sort((a, b) => {
                      if (!showDuplicatesDepotEmplacement) return 0;
                      if (a['Nom Dépôt'] < b['Nom Dépôt']) return -1;
                      if (a['Nom Dépôt'] > b['Nom Dépôt']) return 1;
                      if (a['Emplacement'] < b['Emplacement']) return -1;
                      if (a['Emplacement'] > b['Emplacement']) return 1;
                      return 0;
                    })
                    .map((row, i) => {
                      let backgroundColor = 'transparent';
                      if (showDuplicatesDepotEmplacement) {
                        const currentPair = `${row['Nom Dépôt']}||${row['Emplacement']}`;
                        if (currentPair !== lastPair) { colorToggle = !colorToggle; lastPair = currentPair; }
                        backgroundColor = colorToggle ? '#e0f7fa' : '#b2ebf2';
                      }
                      return (
                        <tr key={i} style={{ backgroundColor }}>
                          {Object.keys(row).map((col, j) => <td key={j}>{row[col]}</td>)}
                        </tr>
                      );
                    });
                })()}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ═══════════════════════════════ CARD 27 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '1350px' }} onClick={() => handleCardClick('card27')}>
        <Card27 />
      </div>

      {card27Clicked && (
        <div className="table-containerstock">
          <table className="inventory-table">
            <thead><tr>{Object.keys(emplacementData[0] || {}).map((col, i) => <th key={i}>{col}</th>)}</tr></thead>
            <tbody>
              {emplacementData.map((row, i) => (
                <tr key={i}>{Object.keys(row).map((col, j) => <td key={j}>{row[col]}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ═══════════════════════════════ CARD 39 ═══════════════════════════════ */}
      <div className="card1" style={{ position: 'absolute', top: '120px', left: '1600px' }} onClick={() => handleCardClick('card39')}>
        <Card39 />
      </div>

      {card39Clicked && (
        <div className="table-containerstock">
          {tachesData.length === 0 ? (
            <p style={{ padding: '20px', color: '#888' }}>Aucune tâche LOG ouverte.</p>
          ) : (
            <table className="inventory-table">
              <thead>
                <tr>{TABLE39_COLUMNS.map((col, i) => <th key={i} style={{ width: getTable39ColWidth(col), minWidth: getTable39ColWidth(col) }}>{col}</th>)}</tr>
              </thead>
              <tbody>
                {tachesData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {TABLE39_COLUMNS.map((col, colIndex) => {
                      if (col === 'Commentaires') return (
                        <td key={colIndex}>
                          <textarea
                            value={row['Commentaires'] || ''}
                            onChange={e => handleTacheCommentaireChange(rowIndex, e.target.value)}
                            onBlur={() => saveTacheCommentaire(row)}
                            placeholder="Ajouter un commentaire"
                            style={{ width: '100%', minHeight: '60px', resize: 'vertical', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', padding: '4px 6px', fontFamily: 'inherit', boxSizing: 'border-box' }}
                          />
                        </td>
                      );
                      if (col === 'Statut') return (
                        <td key={colIndex} className={getStatutClass(row['Statut'])}>
                          <select value={row['Statut'] || 'ouvert'} onChange={e => handleTacheStatutChange(rowIndex, e.target.value)}>
                            <option value="ouvert">ouvert</option>
                            <option value="en cours">en cours</option>
                            <option value="soldé">soldé</option>
                          </select>
                        </td>
                      );
                      if (col === 'Description') return (
                        <td key={colIndex} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          {row['Description'] && String(row['Description']).includes('Commentaire :') ? (
                            <>
                              {String(row['Description']).split(/(Commentaire\s*:\s*[\s\S]*)/).map((part, idx) =>
                                /Commentaire\s*:\s*[\s\S]+/.test(part)
                                  ? <span key={idx} style={{ color: 'red', fontWeight: 'bold' }}>{part}</span>
                                  : <span key={idx}>{part}</span>
                              )}
                            </>
                          ) : row['Description']}
                        </td>
                      );
                      return <td key={colIndex}>{col === 'Date' ? formatDate(row['Date']) : (row[col] ?? '')}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* ═══════════════════════════════ CHARTS ═══════════════════════════════ */}
      {isChartVisible && (
        <>
          <div className="graphique" style={{ position: 'absolute', top: '300px', left: '470px' }}>
            <Camembert2 width={500} height={500} />
          </div>
          <div className="graphique" style={{ position: 'absolute', top: '300px', left: '1150px' }}>
            <Camembert4 width={400} height={400} />
          </div>
        </>
      )}

    </div>
  );
};

export default Gestiondesstocks;